import * as Sentry from "@sentry/browser";
import { HttpInterceptor } from "../../http.interceptor";
import { PerformanceSentry } from "../performance.sentry";
var ResourcePerformanceSentry = /** @class */ (function () {
    function ResourcePerformanceSentry(entry, startTime, parentSpan) {
        this.entry = entry;
        this.startTime = startTime;
        this.parentSpan = parentSpan;
    }
    ResourcePerformanceSentry.prototype.generateSpan = function () {
        var recordedHttpRequest = HttpInterceptor.findRequestByUrlAndTime(this.entry.name, this.entry.startTime);
        // TODO other requests Details like FETCH & PROTOC
        if (recordedHttpRequest) {
            if (recordedHttpRequest.__type === "graphql") {
                this.generateGraphQLSpan(this.entry, this.startTime, this.parentSpan, recordedHttpRequest);
                return;
            }
            if (recordedHttpRequest.__type === "http") {
                this.generateHTTPSpan(this.entry, this.startTime, this.parentSpan, recordedHttpRequest);
                return;
            }
        }
        // IGNORE LEMONERO CSP REPORT requests
        if ([
            "https://middleware.lemonero.com/csp-report-to",
            "https://middleware.lemonero.cz/csp-report-to",
            "https://mob.lemonero.com/csp-report-to",
            "https://mob.lemonero.cz/csp-report-to",
            "https://support.lemonero.com/csp-report-to",
            "https://app.lemonero.com/csp-report-to",
            "https://app.lemonero.cz/csp-report-to",
            "https://multisupp.lemonero.com/csp-report-to",
        ].includes(this.entry.name)) {
            return;
        }
        // IGNORE non-LEMONERO requests
        var url = new URL(this.entry.name);
        if (["lemonero.cz", "lemonero.com"].some(function (domain) { return url.hostname.endsWith(domain); }) === false) {
            return;
        }
        this.generateFetchSpan(this.entry, this.startTime, this.parentSpan);
    };
    ResourcePerformanceSentry.prototype.generateGraphQLSpan = function (entry, startTime, parentSpan, foundQuery) {
        var parsedURL = new URL(entry.name, location.origin);
        var event = Sentry.startInactiveSpan({
            op: "http.client",
            name: "".concat(entry.name),
            startTime: PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime),
            parentSpan: parentSpan,
        });
        event.setAttribute("server.address", parsedURL.hostname);
        event.setAttribute("server.port", parsedURL.port || undefined);
        event.setAttribute("http.request.url", foundQuery.url);
        event.setAttribute("http.request.method", foundQuery.request.method || "POST");
        event.updateName("GRAPHQL - ".concat(foundQuery.request.operationName));
        event.setAttribute("graphql.request.operationName", foundQuery.request.operationName);
        event.setAttribute("graphql.request.variables", JSON.stringify(foundQuery.request.variables));
        if (foundQuery.response) {
            event.setAttribute("graphql.response.data", JSON.stringify(foundQuery.response.data));
            event.setAttribute("graphql.response.content_length", foundQuery.response.contentLength || "0");
            event.setAttribute("graphql.response.status", foundQuery.response.status);
            event.setAttribute("graphql.response.status_text", foundQuery.response.statusText);
            event.setAttribute("http.response.status_code", foundQuery.response.status);
            event.setAttribute("http.response_content_length", foundQuery.response.contentLength || 0);
            event.setStatus({
                code: foundQuery.response.status === 200 ? 1 : 2,
                message: foundQuery.response.statusText,
            });
        }
        event.end(PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime + Math.abs(entry.duration)));
    };
    ResourcePerformanceSentry.prototype.generateHTTPSpan = function (entry, startTime, parentSpan, foundQuery) {
        var parsedURL = new URL(entry.name, location.origin);
        var event = Sentry.startInactiveSpan({
            op: "".concat(entry.entryType, ".").concat(entry.initiatorType),
            name: "".concat(entry.name),
            startTime: PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime),
            parentSpan: parentSpan,
        });
        event.setAttribute("server.address", parsedURL.hostname);
        event.setAttribute("server.port", parsedURL.port || undefined);
        event.setAttribute("http.request.method", foundQuery.request.method || "POST");
        // event.updateName(`GRAPHQL - ${foundQuery.url}`)
        if (foundQuery.response) {
            event.setAttribute("http.response.data", JSON.stringify(foundQuery.response.data));
            event.setAttribute("http.response.content_length", foundQuery.response.contentLength || "0");
            event.setAttribute("http.response.status", foundQuery.response.status);
            event.setAttribute("http.response.status_text", foundQuery.response.statusText);
            event.setAttribute("http.response.status_code", foundQuery.response.status);
            event.setAttribute("http.response_content_length", foundQuery.response.contentLength || 0);
            event.setStatus({
                code: foundQuery.response.status === 200 ? 1 : 2,
                message: foundQuery.response.statusText,
            });
        }
        event.end(PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime + Math.abs(entry.duration)));
    };
    ResourcePerformanceSentry.prototype.generateFetchSpan = function (entry, startTime, parentSpan) {
        var parsedURL = new URL(entry.name, location.origin);
        var event = Sentry.startInactiveSpan({
            op: "".concat(entry.entryType, ".").concat(entry.initiatorType),
            name: "".concat(entry.name),
            startTime: PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime),
            parentSpan: parentSpan,
        });
        event.setAttribute("server.address", parsedURL.hostname);
        event.setAttribute("server.port", parsedURL.port || undefined);
        event.setAttribute("http.request.method", "GET");
        event.end(PerformanceSentry.parseMillisecondsToSeconds(startTime + entry.startTime + Math.abs(entry.duration)));
    };
    return ResourcePerformanceSentry;
}());
export { ResourcePerformanceSentry };
//# sourceMappingURL=resource.performance.sentry.js.map